import request from '@/utils/request'


// 查询印刷倍数列表
export function listPrintMultiplesOption(query) {
  return request({
    url: '/user/print-multiples-option/list',
    method: 'get',
    params: query
  })
}

// 查询印刷倍数分页
export function pagePrintMultiplesOption(query) {
  return request({
    url: '/user/print-multiples-option/page',
    method: 'get',
    params: query
  })
}

// 查询印刷倍数详细
export function getPrintMultiplesOption(data) {
  return request({
    url: '/user/print-multiples-option/detail',
    method: 'get',
    params: data
  })
}

// 新增印刷倍数
export function addPrintMultiplesOption(data) {
  return request({
    url: '/user/print-multiples-option/add',
    method: 'post',
    data: data
  })
}

// 修改印刷倍数
export function updatePrintMultiplesOption(data) {
  return request({
    url: '/user/print-multiples-option/edit',
    method: 'post',
    data: data
  })
}

// 删除印刷倍数
export function delPrintMultiplesOption(data) {
  return request({
    url: '/user/print-multiples-option/delete',
    method: 'post',
    data: data
  })
}
